import React, { useState, useEffect } from 'react'
import Link from 'next/link';
import { useSelector, useDispatch } from 'react-redux';
import { windowRef } from '@util/window';

function StickyCart() {
    const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
    const currentPage = useSelector((state: any) => state.currentPage);
    const [total, setTotal] = useState(0);
    const cartItems = useSelector((state: any) => state.orderItems);
    const cartAppointment = useSelector((state: any) => state.appointmentServices);
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [totalHrs, setTotalHrs] = useState<any>(0);
    const store = useSelector((state: any) => state);
    const languageData: any = store.languageKeywords
    const [disabledBooking, setDisabledBooking] = useState(false)

    useEffect(() => {
        if (windowRef) {
            document.body.style.overflow = 'unset';
            const bookingOnStoreOff = Boolean(configData.storeConfig.appointmentConfig?.bookingOnStoreOff)
            if ((configData?.readOnlyMenu || configData?.storeOff) && bookingOnStoreOff) {
                setDisabledBooking(true);
            }
        }
    }, [windowRef, cartItems, cartAppointment])

    useEffect(() => {
        if (cartItems && cartItems.length) {
            let totalCopy = 0;
            cartItems.map((cartItem) => {
                totalCopy += (cartItem.price * cartItem.quantity);
            })
            setTotal(totalCopy);
        } else {
            setTotal(0);
        }
    }, [cartItems])

    useEffect(() => {
        if (cartAppointment && cartAppointment.length) {
            let totalHrs: any = 0;
            cartAppointment.map((item) => {
                totalHrs += (item.durationType?.includes('min')) ? parseFloat(item.duration) / 60 : parseFloat(item.duration);
            })
            setTotalHrs(totalHrs.toFixed(2));
        } else {
            setTotalHrs(0);
        }
    }, [cartAppointment])

    const isCatalogueEnabled = Boolean(configData?.storeConfig?.basicConfig?.catalogue);

    return (
        <>
            {(isCatalogueEnabled && configData.orderingOn && !configData.storeConfig?.appointmentConfig?.active && cartItems && cartItems?.length != 0 && currentPage != 'cart' && currentPage != 'checkout' && currentPage != 'appointment' && currentPage != 'invoice' && currentPage != 'postcare') ? <Link href={baseRouteUrl + 'cart'} shallow={true}>
                <div className="viewcartbar" style={{ bottom: disabledBooking ? "70px" : "0px" }} >
                    <div className="vcbitem">
                        {cartItems.length > 1 ? <>{cartItems.length} Items</> : <>{cartItems.length} Item</>}
                    </div>
                    <div className="vcbprice">{configData.currencySymbol} {total}</div>
                    <div className="vcbtxt">View Cart</div>
                </div>
            </Link> : null}
            {(isCatalogueEnabled && configData.storeConfig?.appointmentConfig?.active && cartAppointment?.length != 0 && currentPage != 'cart' && currentPage != 'checkout' && currentPage != 'appointment' && currentPage != 'invoice' && currentPage != 'postcare') ? <Link href={baseRouteUrl + 'appointment'} shallow={true}>
                <div className="viewcartbar" style={{ bottom: disabledBooking ? "70px" : "0px" }} >
                    <div className="vcbitem">
                        {cartAppointment.length > 1 ? <>{cartAppointment.length} {languageData["Services"] ? languageData["Services"] : "Services"}</> : <>{cartAppointment.length} Service</>}
                    </div>
                    {totalHrs != '0.0' && totalHrs != '0.00' && <>
                        <div className="vcbprice">
                            {totalHrs > 1 ? <>{totalHrs} Hrs</> : <>{totalHrs} Hr</>}
                        </div>
                    </>}
                    <div className="vcbtxt">{languageData["Book Appointment"] ? languageData["Book Appointment"] : "Book Appointment"}</div>
                </div>
            </Link> : null
            }
        </>
    )
}

export default StickyCart;
